import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Container, Box, Typography, Button, Paper } from "@mui/material";
import {
  Home as HomeIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { useThemeMode } from "../contexts/ThemeContext";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const navigate = useNavigate();
  const { mode } = useThemeMode();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        minWidth: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          mode === "dark"
            ? `radial-gradient(50% 50% at 57% 115%, var(--color-102) 0%, rgba(41, 74, 77, 0.00) 100%), var(--color-34)`
            : `radial-gradient(50% 50% at 57% 115%, var(--color-21) 0%, rgba(229, 244, 242, 0.00) 100%), var(--color-108)`,
        position: "fixed",
        top: 0,
        insetInlineStart: 0,
        insetInlineEnd: 0,
        bottom: 0,
        overflow: "auto",
        p: 3,
        "&::before": {
          content: '""',
          position: "absolute",
          insetInlineStart: "-190px",
          bottom: "-289px",
          width: "1820px",
          height: "673px",
          borderRadius: "1820px",
          opacity: 0.6,
          background:
            "radial-gradient(50% 50% at 50% 50%, var(--color-102) 0%, rgba(41, 74, 77, 0.00) 100%)",
          pointerEvents: "none",
          zIndex: 0,
        },
      }}
    >
      <Paper
        sx={{
          p: 5,
          maxWidth: 500,
          textAlign: "center",
          borderRadius: 2,
          background:
            mode === "light" ? "rgba(255, 255, 255, 0.9)" : "var(--color-109)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          sx={{ fontSize: "6rem", fontWeight: 700, mb: 2 }}
        >
          404
        </Typography>
        <Typography variant="h4" component="h2" gutterBottom>
          {t('notFound.title')}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          paragraph
          sx={{ mb: 4 }}
        >
          {t('notFound.description')}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            maxWidth: "300px",
            mx: "auto",
          }}
        >
          <Button
            component={RouterLink}
            to="/"
            fullWidth
            variant="contained"
            startIcon={<HomeIcon />}
            sx={{
              py: 1.5,
              fontWeight: 600,
              textTransform: "none",
              borderRadius: "100px",
            }}
          >
            {t('notFound.goToDashboard')}
          </Button>

          <Button
            onClick={handleGoBack}
            fullWidth
            variant="outlined"
            startIcon={isRTL ? <ArrowForwardIcon /> : <ArrowBackIcon />}
            sx={{
              textTransform: "none",
              borderRadius: "100px",
            }}
          >
            {t('notFound.goBack')}
          </Button>

          <Button
            component={RouterLink}
            to="/playground"
            fullWidth
            variant="outlined"
            startIcon={<SearchIcon />}
            sx={{
              borderRadius: "100px",
            }}
          >
            {t('notFound.tryPlayground')}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFound;
